module.exports = __webpack_public_path__ + "static/media/awards_1.00cc3741.jpg";